<template>
  <b-row class="tl-row">
    <b-col
      qa="tracking-step-datetime-div"
      cols="auto"
      class="d-flex align-items-center mb-4"
    >
      {{ step.changeDate | datetime }}
    </b-col>
    <b-col
      cols="auto"
      class="p-0 d-none d-md-flex align-items-center justify-content-center"
    >
      <div
        class="tr-circle d-flex align-items-center justify-content-center"
      />
      <div
        v-if="!singleItem"
        class="time-line"
      />
    </b-col>
    <b-col class="d-flex align-items-center">
      <div class="arrow-bubble" />
      <div class="speech-bubble w-100 mb-4">
        <div class="arrow left" />
        <b-row class="px-3">
          <b-col lg="auto">
            <div
              class="d-flex flex-column align-items-start justify-content-start"
            >
              <small>{{
                $t("globalLocator.labels.status")
              }}</small>
              <study-request-status-badge
                qa="tracking-step-status-span"
                class="status-badge"
                :status="step.status"
              />
            </div>
          </b-col>
          <b-col lg>
            <b-row>
              <b-col
                lg="12"
                xl="6"
              >
                <div
                  v-if="step.userapp"
                  class="d-flex flex-column align-items-start justify-content-start"
                >
                  <small>{{ $t("globalLocator.labels.user") }}</small>
                  <span
                    qa="tracking-step-fullname-span"
                    class="user label-dark"
                  >{{ step.userapp.fullName }}</span>
                </div>
              </b-col>
              <b-col
                class="mt-lg-2 mt-xl-0"
                lg="12"
                xl="6"
              >
                <div
                  v-if="step.userapp"
                  class="d-flex flex-column align-items-start justify-content-start"
                >
                  <small>{{ $t("globalLocator.labels.laboratory") }}</small>
                  <span
                    qa="tracking-step-laboratory-span"
                    class="user label-dark"
                  >{{ step.laboratory.labName }}</span>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import StudyRequestStatusBadge from '@/modules/clinicalModule/components/StudyRequestStatusBadge'

export default {
    name: 'TrackingStep',
    components: {
        StudyRequestStatusBadge
    },
    props: {
        step: { type: Object, required: true },
        last: { type: Boolean },
        singleItem: { type: Boolean }
    }
}
</script>

<style lang="scss" scoped>
.tr-circle {
    width: 25px;
    height: 25px;
    border: 2px solid vt-color(primary);
    border-radius: 50%;
    background: vt-color(white-light);
    position: relative;
    z-index: 5;
    margin: -10px 10px 10px 10px;
}

.time-line {
    width: 3px;
    height: 100%;
    background: vt-color(primary);
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: 0;
    position: absolute;
}

.tl-row:first-child .time-line {
    top: 50%;
}

.tl-row:last-child .time-line {
    height: 50%;
}

.speech-bubble .description {
    line-height: 20px;
}

.speech-bubble .title,
.speech-bubble .user {
    font-size: font-size(very-small) !important;
    color: vt-color(dark-text);
    text-align: left;
}

.speech-bubble {
    background-color: vt-color(white-light);
    border: 1px solid #c8c8c8;
    border-radius: 5px;
    text-align: center;
    padding: 10px;
    position: relative;
    box-shadow: 1px 1px 5px 0 hsla(0, 0%, 49%, 0.64);
}

.speech-bubble .arrow {
    border-style: solid;
    position: absolute;
}

.left {
    border-color: #c8c8c8 transparent transparent transparent;
    border-width: 8px 8px 0px 8px;
    left: -12px;
    top: calc(50% - 5px);
    transform: rotate(90deg);
}

.left:after {
    border-color: vt-color(white-light) transparent transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0px 7px;
    bottom: 1px;
    content: "";
    position: absolute;
    left: -7px;
}

.step {
    width: 100%;
    margin-left: 100px;
}
</style>
